export default __webpack_public_path__ + "static/tampico-7a011b04a7769b264f0f7a7f9081ef6d.jpg";